import gql from 'graphql-tag'

export default gql`
mutation createUser($record: CreateOneUserInput!) {
  createUser(record: $record) {
    record {
      _id
      username
      name
      role
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/createUser.js